module.exports = __webpack_public_path__ + "static/ShopDashboard-e4dbda07c0eda097174f683e0dc82f7a.png";